var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnknownBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white",
    stroke: "#EB5757",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3765 9.04188C15.2685 7.30295 13.8758 5.91024 12.1369 5.80231C10.099 5.67423 8.45166 7.3015 8.45166 9.26129C8.45166 9.77566 8.86866 10.1927 9.38303 10.1927C9.8974 10.1927 10.3144 9.77566 10.3144 9.26129C10.3144 8.33649 11.0911 7.60339 12.0214 7.66147C12.8112 7.71047 13.4683 8.36753 13.5173 9.1573C13.5611 9.86263 13.1492 10.506 12.4923 10.7585C11.5774 11.1102 10.9861 11.9649 10.9861 12.936V13.8545C10.9861 14.3689 11.4031 14.7859 11.9174 14.7859C12.4318 14.7859 12.8488 14.3689 12.8488 13.8545V12.936C12.8488 12.7422 12.9712 12.57 13.1606 12.4973C14.5804 11.9517 15.4709 10.563 15.3765 9.04188V9.04188Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9177 18C12.4321 18 12.8491 17.583 12.8491 17.0686C12.8491 16.5542 12.4321 16.1372 11.9177 16.1372C11.4033 16.1372 10.9863 16.5542 10.9863 17.0686C10.9863 17.583 11.4033 18 11.9177 18Z",
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownBlank);
export default __webpack_public_path__ + "static/media/unknown-blank.cfb3fa37.svg";
export { ForwardRef as ReactComponent };